module.exports = __webpack_public_path__ + "img/id.960b7be8.svg";